export default class Action {

    static CHANGE_LANG = 'CHANGE_LANG'
    static DATA_DYNAMIC = 'DATA_DYNAMIC'
    static MODAL_VISIBLE = 'MODAL_VISIBLE'
}